// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2zbeb","modalForm":"UpgradeEpcsModal_modalForm__1zpxq","modalFooter":"UpgradeEpcsModal_modalFooter__2RV2v"};